import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = "/api";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language preference or default to English
    return localStorage.getItem('language') || 'en';
  });
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTranslations();
  }, []);

  useEffect(() => {
    // Save language preference
    localStorage.setItem('language', language);
  }, [language]);

  const fetchTranslations = async () => {
    try {
      const response = await axios.get(`${API}/translations`);
      // Convert array to object keyed by translation key
      const translationMap = {};
      response.data.forEach(t => {
        translationMap[t.key] = t;
      });
      setTranslations(translationMap);
    } catch (error) {
      console.error('Failed to fetch translations:', error);
    } finally {
      setLoading(false);
    }
  };

  const t = (key, fallback = '') => {
    const translation = translations[key];
    if (!translation) {
      return fallback || key;
    }
    return translation[language] || translation.en || fallback || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ja' : 'en');
  };

  const setLang = (lang) => {
    if (lang === 'en' || lang === 'ja') {
      setLanguage(lang);
    }
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage: setLang, 
      toggleLanguage, 
      t, 
      translations,
      loading,
      refreshTranslations: fetchTranslations
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
